import React from 'react'
import jsPDF from 'jspdf'
import html2canvas from 'html2canvas'
import logo from '../static/images/New_logo.jpg'
import useDownloadPdf from '../hooks/DownloadPdf'
import apiRequest from '../hooks/ApiRequest'

function roundvalue(value) {
  if (value > 0) {
    return parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0])
  }
}
class CreditNote extends React.Component {
  constructor(props) {
    super(props);
    this.downloadPdf = useDownloadPdf().generatePdf;

    this.state = {
      originalPolicyData: {},
      policyData: {},
      RefundableAmount: 0,
    };

    this.calculateRefundableAmount = this.calculateRefundableAmount.bind(this);
  }

  componentDidMount() {
    const { policy } = this.props;
    debugger;

    if (policy) {
      const refundable =
        policy.refund ??
        (policy.riskitemdetails && policy.riskitemdetails.length > 0
          ? policy.riskitemdetails[0].refund
          : 0);

      this.setState({
        originalPolicyData: { ...policy },
        policyData: {
          ...policy,
          premium: policy.grandtotalannualpremium || policy.totalannualpremium || 0,
        },
        RefundableAmount: refundable || 0,
      });

    }
  }


  calculateRefundableAmount(newData) {
    const { originalPolicyData } = this.state;

    // compare new premium / end date etc. with original
    let premium = newData.premium || originalPolicyData.premium;
    let endDate = newData.policyexpirydate || originalPolicyData.policyexpirydate;
    let cancellationDate = newData.policycancelleddate || originalPolicyData.policycancelleddate;

    const dayDiff = Math.floor(
      (new Date(endDate) - new Date(cancellationDate)) / (1000 * 60 * 60 * 24)
    ) + 1;

    const refundable = parseFloat((premium * (dayDiff / 365)).toFixed(2));

    this.setState({
      policyData: { ...this.state.policyData, ...newData },
      RefundableAmount: refundable,
    });
  }

  render() {
    const { policyData, RefundableAmount } = this.state;

    return (
      <div className="white-box-bg">
        <div className="dash-heading">
          <h3>CREDIT NOTE </h3>
        </div>

        <div id="divToPrint" className="form-group-box position-relative">

          <div className="outrisk-logo"><img src={logo} className="logo-img" style={{ width: '250px' }} /></div>

          <div className="customer-main-block">
            <div className="customer-heading">
              <h4>Customer Name : {policyData.clientname}</h4>
            </div>

            <div className="policy-list-details">
              <ul>
                <li><span>Policy number :</span> {policyData.policynumber}</li>
                <li><span>Policy start date :</span> {policyData.policystartdate}</li>
                <li><span>Policy end date :</span> {policyData.policyexpirytdate}</li>
                <li><span>Premium :</span> {policyData.premium}</li>
                <li><span>Refundable amount :</span> {RefundableAmount}</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="cancel-policy-button plr-15">
          <button onClick={() => this.downloadPdf('divToPrint', 'download.pdf')}>
            Download Credit Note
          </button>
        </div>
      </div>
    );
  }

}
export default CreditNote
